import { OrientacionI } from "interfaces/Orientacion";
import { ReactNode } from "react";
import { Table } from "react-bootstrap";
import { OrientacionesRow } from "./OrientacionesRow";
// import { DetailModal } from '../components/DetailModal/DetailModal';

interface Props {
  elementos: OrientacionI[];
  renderActions?: (elemento: OrientacionI) => ReactNode;
}

export const OrientacionesTable = ({
  elementos = [],
  renderActions,
}: Props) => {
  return (
    <>
      <Table striped bordered className="table-container">
        <thead>
          <tr className="table-heading">
            <th>ID</th>
            <th>Nombre</th>
            {renderActions && <th className="text-center">Acciones</th>}
          </tr>
        </thead>
        <tbody>
          {elementos.length > 0 ? (
            elementos.map((ctEl) => (
              <OrientacionesRow
                key={ctEl.id}
                elemento={ctEl}
                renderActions={renderActions}
              />
            ))
          ) : (
            <tr>
              <td
                colSpan={renderActions ? 9 : 8}
                className="text-center table-error-message"
              >
                <p>
                  <b>No hay orientaciones para visualizar.</b> Para poder
                  visualizar orientaciones debes <br /> seleccionar el botón
                  agregar «Nueva orientación».
                </p>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};
